import { Component } from "@bodil/dom/component";
import { html } from "lit";
import { customElement } from "lit/decorators.js";

import { BtkButton } from "./button";

import styles from "./button-bar.css?inline";

declare global {
    interface HTMLElementTagNameMap {
        "btk-button-bar": BtkButtonBar;
    }
}

@customElement("btk-button-bar")
export class BtkButtonBar extends Component {
    private handleSlotChange() {
        const buttons = this.querySlot({ flatten: true, instanceOf: BtkButton });

        const boxy = this.classList.contains("boxy");

        buttons.forEach((button, index) => {
            button.classList.toggle("boxy", boxy);
            const first = index === 0;
            const last = index === buttons.length - 1;
            if (first && last) {
                return;
            }
            button.classList.add("borkbot-button-bar-member");
            button.classList.toggle("borkbot-button-bar-first", first);
            button.classList.toggle("borkbot-button-bar-inner", !first && !last);
            button.classList.toggle("borkbot-button-bar-last", last);
            button.style.setProperty("--borkbot-button-bar-ordinal", `${index}`);
        });
    }

    protected override render(): unknown {
        return html`<slot @slotchange=${this.handleSlotChange}></slot>`;
    }

    static styles = styles;
}
